module.exports = __webpack_public_path__ + "static/WEDDING E&M-92-82f750d45a1f12c16b5c5f543ddf2a44.jpg";